import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import AffiliatesPanel from "./AffiliatesPanel";
import { api, errorMessage } from "./api";
import { TierConfiguration } from "../../util/api/affiliateApi";
import AffiliateNotice from "../../components/AffiliateNotice";
import TierSettings from "./TierSettings";
import { SupportSession } from "./types";

export default function AffiliatesPage({ session, onLogout }: { session: SupportSession; onLogout: () => void }) {
  const [signingOut, setSigningOut] = useState(false);
  const [configuration, setConfiguration] = useState<TierConfiguration | null>(null);
  const [error, setError] = useState("");
  const loadTiers = async () => { try { setConfiguration(await api.queryTiers(session.csrf_token)); setError(""); } catch (reason) { setError(errorMessage(reason)); } };
  useEffect(() => { loadTiers(); }, [session.csrf_token]); // eslint-disable-line react-hooks/exhaustive-deps
  const signOut = async () => {
    setSigningOut(true);
    try { await api.logout(session.csrf_token); }
    finally { onLogout(); }
  };
  return <Box component="main" sx={{ minHeight: "100vh", bgcolor: "background.default", px: { xs: 2, sm: 3, lg: 4 }, py: { xs: 2, sm: 3, lg: 4 } }}>
    <Box sx={{ width: "100%", maxWidth: 1280, mx: "auto", minWidth: 0 }}>
      <Stack component="nav" aria-label="Administration pages" direction="row" justifyContent="space-between" spacing={2} sx={{ mb: 3 }}>
        <Button href="/support-inbox" startIcon={<ArrowBackRoundedIcon />} sx={{ minWidth: 0 }}>Support inbox</Button>
        <Button disabled={signingOut} onClick={() => { signOut().catch(() => undefined); }} sx={{ flexShrink: 0 }}>Sign out</Button>
      </Stack>
      <Box sx={{ mb: 3 }}>
        <Typography variant="overline" color="secondary.main">WaveMind / Administration</Typography>
        <Typography component="h1" variant="h1" sx={{ mt: 0.5 }}>Affiliate accounts</Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>Review applications, manage account access, and set commission rates.</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1, overflowWrap: "anywhere" }}>{session.administrator.display_name} · {session.administrator.role}</Typography>
      </Box>
      <Paper variant="outlined" sx={{ minWidth: 0, overflow: "hidden" }}>
        {error && <AffiliateNotice severity="error">{error}<Button onClick={loadTiers}>Reload tiers</Button></AffiliateNotice>}
        {configuration && <TierSettings configuration={configuration} csrf={session.csrf_token} editable={session.administrator.role === "manager" || session.administrator.is_system_admin === true} onSaved={setConfiguration} />}
        <AffiliatesPanel key={configuration?.revision} csrf={session.csrf_token} configuration={configuration}
          canManageDiscounts={session.administrator.role === "manager" || session.administrator.is_system_admin === true} />
      </Paper>
    </Box>
  </Box>;
}
